/************* POPUP *************/
let speidelScrollbarWidth = window.innerWidth - document.body.offsetWidth;
window.addEventListener('resize', () => {
  speidelScrollbarWidth = window.innerWidth - document.body.offsetWidth;
}, true);

function speidelPopup() {
  const settings = {
    speedOpen: 50,
    speedClose: 150,
    activeClass: "is-active",
    visibleClass: "_is-visible",
    selectorTarget: "[data-modal-target]",
    selectorTrigger: "[data-modal-trigger]",
    selectorClose: "[data-modal-close]",
  };

  const toggleAccessibility = function (event) {
    if (event.getAttribute("aria-expanded") === "true") {
      event.setAttribute("aria-expanded", false);
    } else {
      event.setAttribute("aria-expanded", true);
    }
  };

  const openModal = function (trigger) {
    const target = document.getElementById(trigger.getAttribute("data-modal-trigger"));
    target.classList.add(settings.activeClass);
    document.documentElement.classList.add('_popup-opened');
    toggleAccessibility(trigger);
    document.querySelector("html").style.paddingRight = speidelScrollbarWidth + "px";
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
  };

  const closeModal = function (event) {
    const closestParent = event.closest(settings.selectorTarget);
    closestParent.classList.remove(settings.visibleClass);
    document.documentElement.classList.remove('_popup-opened');
    document.querySelector('html').style.paddingRight = '0px';
    setTimeout(function () {
      closestParent.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  const clickHandler = function (event) {
    const toggle = event.target,
      open = toggle.closest(settings.selectorTrigger),
      close = toggle.closest(settings.selectorClose);
    if (open) {
      openModal(open);
    }
    if (close) {
      closeModal(close);
    }
    if (open || close) {
      event.preventDefault();
    }
  };

  const keydownHandler = function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
      let modals = document.querySelectorAll(settings.selectorTarget);
      for (let i = 0; i < modals.length; ++i) {
        if (modals[i].classList.contains(settings.activeClass)) {
          closeModal(modals[i]);
        }
      }
    }
  };

  window.showModal = function (modalName) {
    let target = document.getElementById(modalName);
    target.classList.add(settings.activeClass);
    target.setAttribute('aria-expanded', true);
    document.documentElement.classList.add('_popup-opened');
    document.querySelector("html").style.paddingRight = speidelScrollbarWidth + "px";
    setTimeout(function () {
      target.classList.add(settings.visibleClass);
    }, settings.speedOpen);
  };

  window.hideModal = function (modalName) {
    let target = document.getElementById(modalName);
    target.classList.remove(settings.visibleClass);
    target.setAttribute('aria-expanded', false);
    document.documentElement.classList.remove('_popup-opened');
    document.querySelector("html").style.paddingRight = "0px";
    setTimeout(function () {
      target.classList.remove(settings.activeClass);
    }, settings.speedClose);
  };

  document.addEventListener("click", clickHandler, false);
  document.addEventListener("keydown", keydownHandler, false);
}

speidelPopup();
/************* END POPUP *************/


/************* QUICK BUY *************/
const collectionQuickAdd = async (btn) => {
  const productCard = btn.closest('.collection__product');
  const productId = btn.getAttribute('data-product-id');
  const variantId = btn.getAttribute('data-variant-id');
  const productHandle = btn.getAttribute('data-product-handle');
  const fits = btn.getAttribute('data-fits');
  const quickBuyPopupBody = document.querySelector('.quick-add-popup__body');
  
  if (!productId || !variantId || !productHandle || !quickBuyPopupBody) return;

  btn.classList.add('loading');
  quickBuyPopupBody.innerHTML = "";

  try {
    const variantOption = productCard && productCard.querySelector('.js-collection-swatch.checked') ? productCard.querySelector('.js-collection-swatch.checked').getAttribute('data-variant-link') : null;
    let endpoint = variantOption ? variantOption : `/products/${productHandle}?variant=${variantId}`;

    const response = await fetch(endpoint);

    if (!response.ok) {
      throw new Error('Product not found');
    }

    const html = await response.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const productSection =  doc ? doc.querySelector('.shopify-section.product-template') : null;

    if (productSection) {
      quickBuyPopupBody.innerHTML = productSection.outerHTML;
      
      const sizeChartModals = quickBuyPopupBody.querySelectorAll('.size-chart-remodal');
      sizeChartModals.forEach(modal => modal.remove());

      const purchaseDetailsBlock = quickBuyPopupBody.querySelector('.purchase-details__buttons');
      if (fits && purchaseDetailsBlock) {
        purchaseDetailsBlock.insertAdjacentHTML('beforebegin', `<p class="fits-info"><span>Fits:</span> ${fits}</p>`);
      }

      const purchaseDetailsButton = quickBuyPopupBody.querySelector('.purchase-details__buttons');
      const leadTime = window.getLeadTime();
      if (leadTime && purchaseDetailsButton) {
        purchaseDetailsButton.insertAdjacentHTML('afterend', `<p class="lead-time-popup">${leadTime}</p>`);
      }

      if (!productSection.querySelector('coco-shuffle') && window.productPage && typeof window.productPage.init === 'function') {
        window.productPage.init();
        window.productPage.productSwatches();
        window.productPage.initializeQuantityBox();
      }
      
      window.showModal('quick-add-popup');
    }
  } catch (error) {
    console.error('Error in quick add:', error);
  } finally {
    btn.classList.remove('loading');
  }
}
/************* END QUICK BUY *************/


/************* EVENTS *************/
document.addEventListener('click', (e) => {
  if (!e.target) return;

  if (e.target.classList.contains('collection__product-quick-add')) {
    collectionQuickAdd(e.target);
  }
});

document.addEventListener('DOMContentLoaded', () => {
  window.addLeadTimeToCards();
});
/************* END EVENTS *************/